import { render } from "./file.vue?vue&type=template&id=11512b94&scoped=true"
import script from "./file.vue?vue&type=script&lang=ts&setup=true"
export * from "./file.vue?vue&type=script&lang=ts&setup=true"

import "./file.vue?vue&type=style&index=0&id=11512b94&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-11512b94"
/* hot reload */
if (module.hot) {
  script.__hmrId = "11512b94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11512b94', script)) {
    api.reload('11512b94', script)
  }
  
  module.hot.accept("./file.vue?vue&type=template&id=11512b94&scoped=true", () => {
    api.rerender('11512b94', render)
  })

}

script.__file = "resources/ts/components/form/file.vue"

export default script